export const playPause = (): void => {
  const playPauseButton = document.getElementById("playPauseButton") as HTMLElement
  const video = document.getElementById("backgroundVideo") as HTMLIFrameElement

  playPauseButton?.addEventListener("click", (e) => onClick(e, video))
}

const onClick = (e: Event, video: HTMLIFrameElement): void => {
  const playPauseButton = e.target as HTMLElement
  if (video && video.contentWindow) {
    const src = new URL(video.src)

    const hostname = src.hostname

    if (playPauseButton?.classList.contains("pause")) {
      playPauseButton.classList.remove("pause")
      playPauseButton.classList.add("play")

      if (hostname.includes("youtube")) {
        video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
      } else if (hostname.includes("vimeo.com")) {
        video.contentWindow.postMessage('{"method":"pause"}', "*")
      }
    } else {
      playPauseButton.classList.remove("play")
      playPauseButton.classList.add("pause")

      if (hostname.includes("youtube")) {
        video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*")
      } else if (hostname.includes("vimeo.com")) {
        video.contentWindow.postMessage('{"method":"play"}', "*")
      }
    }
  }
}
